/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useContext, useEffect } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import isEmpty from 'lodash-es/isEmpty';
import { WorkspaceContext } from '/views/workspace/workspaceContext';

const { updateFilter, updateQueryString } = WorkspaceActionCreator;

/**
 * Custom renderer for the actions available to change the chart settings.
 *
 * This is a Filter Provider for the ParaCord chart.
 *
 * @param chartConfiguration
 * @param actions
 * @returns {*}
 * @constructor
 */
export const ParaCordActions = ({ actions }) => {
  const {
    state: {
      explorer: { filters: { paracord: paracordFilter = {} } },
    }, dispatch,
  } = useContext(WorkspaceContext);

  const onFilter = () => {
    if (actions?.selected.length) {
      const newFilter = {};
      actions.selected.forEach(node => {
        newFilter[node.propertyKey] = {
          ...newFilter[node.propertyKey],
          [node.key]: true,
        };
      });
      dispatch(updateFilter('paracord', newFilter));
    } else {
      dispatch(updateFilter('paracord', null));
    }
  };

  useEffect(() => {
    if (isEmpty(paracordFilter))
      return;

    let queryString = Object.entries(paracordFilter || {}).map(([key, values]) => {
      const keyValues = Object.keys(values).map(value => ({ [key]: value }));
      return {
        $or: keyValues,
      };
    });

    dispatch(updateQueryString('paracord', { $and: queryString }));
  }, [paracordFilter, dispatch]);


  return (
    <React.Fragment>
      {actions?.selected?.length ?
      <Button intent={Intent.PRIMARY}
              onClick={onFilter}>
        {`Filter ${actions.selected.length} value${actions.selected.length > 1 ? 's' : ''}`}
      </Button> : null
      }
    </React.Fragment>
  );
};
